import { SettingsInputComponentOutlined } from '@material-ui/icons'
import { checkManufacturability } from 'features/BillOfMaterials/store/asyncActions/checkManufacturability'
import { bomItemWorkingStepsSelector } from 'features/BillOfMaterials/store/selectors/bomItemWorkingStepsSelector'
import { ProjectInBuyerViewSelector } from 'features/BillOfMaterials/store/selectors/projectInBuyerViewSelector'
import { useAppSelector } from 'store/configureStore'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { BomItemMenuItem } from './BomItemMenuItem'

export const CheckManufacturabilityMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  const bomItemWorkingSteps = useAppSelector(
    bomItemWorkingStepsSelector({ bomItemId })
  )
  const isBuyerView = useAppSelector(ProjectInBuyerViewSelector)

  if (
    isBuyerView ||
    bomItemWorkingSteps.findIndex(
      (x) => x.primaryWorkingStep === WorkingStepType.SheetBending
    ) === -1
  ) {
    return null
  }

  return (
    <BomItemMenuItem
      action={checkManufacturability}
      actionParams={{ bomItemId }}
      closeAfterFullfilled
      onClose={onClose}
      primaryTextTranslationKey="project:context-check-manufacturability"
      secondaryTextTranslationKey="project:context-check-manufacturability-desc"
      icon={<SettingsInputComponentOutlined />}
    />
  )
}
